import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { IMember, IMemberState } from "./Member.types";

const initialState: IMemberState = {
  members: [],
  isLoading: false,
  error: null,
};

const memberSlice = createSlice({
  name: "member",
  initialState,
  reducers: {
    setMembers: (state, action: PayloadAction<IMember[]>) => {
      state.members = action.payload;
    },
  },
});

export const { setMembers } = memberSlice.actions;

export default memberSlice.reducer;
